import { IEventV3 } from '../data/entities/event';
import { IBookingV3 } from '../data/entities/event/booking';
import { fromFloyd } from '../entities/pricing/helpers';

const convertFromFloyd = (booking: IBookingV3): IBookingV3 => {
	return {
		...booking,
		booking_value: {
			...booking.booking_value,
			owner_rent_value: booking.booking_value?.owner_rent_value ? fromFloyd(booking.booking_value?.owner_rent_value) : 0,
			tn_booking_discrepancy: booking.booking_value?.tn_booking_discrepancy ? fromFloyd(booking.booking_value?.tn_booking_discrepancy) : 0,
			tbv: booking.booking_value?.tbv ? fromFloyd(booking.booking_value?.tbv) : 0,
		},
	};
};

export const transformInboundBookingEventV3 = (bookingEvent: IEventV3): IEventV3 => {
	return {
		...bookingEvent,
		booking: bookingEvent.booking ? convertFromFloyd(bookingEvent.booking) : bookingEvent.booking as any,
	};
};
